module.exports = __webpack_public_path__ + "static/media/prize1.c117196c.jpg";